<template>
  <div class="testv__footer__wrapper">
    <div class="testv__footer__left">
      <img :src="logo" class="logo"/>
    </div>
    <div class="testv__footer">
      <IconLogoTestv class="LogoTestv"/>
      <div>
        <span>&copy; 2013-{{ new Date().getFullYear() }} 少数派 </span>
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备09128966号-4 </a>
        <a href="https://dxzhgl.miit.gov.cn/" target="_blank">粤B2-20211534 </a>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/footer@2x.png'
export default {
  name: 'TestvFooter',

  data () {
    return {
      logo: logo
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl'
.testv__footer__wrapper {
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  @media (min-width: $screen-md) {
    column-gap: 35px;
  }
}
.testv__footer {
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 13px;
  color: var(--dark-bwb-3);
  flex: 1;
  max-width: 600px;
  .LogoTestv {
    display: none;
  }
}
.testv__footer__left {
  position: relative;
  width: 32px;
  @media (min-width: $screen-md) {
    width: 96px;
  }
}
.logo {
  position: absolute;
  right: 0px;
  bottom: 16px;
  width: 16px;
}
</style>
